import {
    useCallback,
    useState,
    useMemo
} from "react";

export default function useStorage({key, initialValue, serialize}) {
    const storageKey = Array.isArray(key)
        ? key.join('.')
        : key;

    const resetValue = initialValue ?? null;
    const current = useMemo(() => {
        const storageValue = localStorage.getItem(storageKey);
        if (storageValue) {
            return storageValue;
        }
        return serialize
            ? JSON.stringify(initialValue)
            : initialValue;
    }, [storageKey, serialize, initialValue]);

    const init = useMemo(() => {
        return current && serialize
            ? JSON.parse(current)
            : current;
    }, [current, serialize]);

    const [storageValue, _setStorageValue] = useState(init);

    const setStorageValue = useCallback(value => {
        const newValue = typeof value === 'function'
            ? value(storageValue)
            : value;

        _setStorageValue(newValue);
        const persistingValue = newValue && serialize
            ? JSON.stringify(newValue)
            : newValue;
        localStorage.setItem(storageKey, persistingValue);
    }, [storageKey, serialize, storageValue]);


    const deleteValue = useCallback(() => {
        _setStorageValue(resetValue);
        localStorage.removeItem(storageKey);
    }, [storageKey, resetValue]);

    return [storageValue, setStorageValue, deleteValue];
}